import styled from 'styled-components';
import { Modal } from 'antd';

export const Error = styled.div`
  color: red;
`;

export const SectionHeader = styled.h3`
  margin: 24px 0 8px;
`;

export const StyledModal = styled(Modal)`
  .ant-modal-footer {
    button:nth-child(1) {
      float: left;
      margin-left: 8px;
    }
  }
`;
